const filterThroughFacets = (
    searchText: string,
    facets: string[],
    filterName: string,
    includeFacetInTopFive?: string,
) => {
    let facetsToFilterThrough = [] as string[]
    if (facets) {
        facetsToFilterThrough = facets
    } else {
        return {filteredFacetsOfTopFive: [], restOfFilteredFacets: []}
    }

    const facetToInclude = `${filterName}:${includeFacetInTopFive ?? ""}`.toLowerCase()

    if (
        includeFacetInTopFive &&
        facetsToFilterThrough.length > 0 &&
        facetsToFilterThrough.includes(facetToInclude) &&
        facetsToFilterThrough[0] !== facetToInclude
    ) {
        facetsToFilterThrough.splice(facetsToFilterThrough.indexOf(facetToInclude), 1)
        facetsToFilterThrough.unshift(facetToInclude)
    }
    const topFiveFacets = facetsToFilterThrough.slice(0, 5)
    const restOfFacetItems = facetsToFilterThrough.slice(5, facetsToFilterThrough.length)
    const filteredFacetsOfTopFive = [] as string[]
    const restOfFilteredFacets = [] as string[]
    if (topFiveFacets.length > 0) {
        topFiveFacets.forEach(filter => {
            if (filter.split(":")[1].toLowerCase().includes(searchText.toLowerCase())) {
                filteredFacetsOfTopFive.push(filter)
            }
        })
    }

    if (restOfFacetItems.length > 0) {
        restOfFacetItems.forEach(filter => {
            if (filter.split(":")[1].toLowerCase().includes(searchText.toLowerCase())) {
                restOfFilteredFacets.push(filter)
            }
        })
    }
    return {filteredFacetsOfTopFive, restOfFilteredFacets}
}

export default filterThroughFacets
